import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'//苹果
import HuaWei from '../views/HuaWei.vue'//华为
import IndexWebsite from '../views/IndexWeb.vue'//猪猪小程序官网图片
import IndexApp from '../views/indexApp.vue'

/**
 * 检测用户设备是否为移动设备
 * 
 * 该函数通过正则表达式检查navigator.userAgent字符串中是否包含有移动设备的关键词
 * 如果检测到用户代理字符串中包含'Android'、'webOS'、'iPhone'、'iPod'或'BlackBerry'等关键词
 * 则判定用户设备为移动设备
 * 
 * @returns {boolean} 如果设备是移动设备则返回true，否则返回false
 */
function isMobile(){
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'IndexWebsite',
    component:IndexWebsite,//猪猪小程序官网图片
  },
  {
    path: '/huawei',
    name: 'HuaWei',
    component:HuaWei,//华为
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path:'/indexApp',
    name:"indexApp",
    component:IndexApp
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,from,next)=>{
  if(to.path === '/'){
    if(isMobile()){
      next('/indexApp')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
